import profilePhotoPlaceholder from "../../assets/profile_image_placeholder.png";
class User {
  constructor(
    fullName,
    userName,
    userType,
    email,
    profilePhoto,
    organization,
    phoneNumber,
    jobTitle,
    regions,
    userId,
    _id, // Added _id as a parameter
    favoriteResumes // Added favoriteResumes as a parameter
  ) {
    this.fullName = fullName; // Frontend field
    this.userName = userName;
    this.userType = userType;
    this.email = email;
    this.profilePhoto = profilePhoto;
    this.organization = organization;
    this.phoneNumber = phoneNumber || "";
    this.jobTitle = jobTitle || "";
    if (Array.isArray(regions)) this.regions = regions;
    else if (typeof regions === "string") {
      let parsed = [];
      try {
        const candidate = JSON.parse(regions);
        if (Array.isArray(candidate)) parsed = candidate;
        else parsed = regions.split(",").map((entry) => entry.trim()).filter(Boolean);
      } catch (error) {
        parsed = regions.split(",").map((entry) => entry.trim()).filter(Boolean);
      }
      this.regions = parsed;
    } else if (regions) {
      this.regions = [regions];
    } else {
      this.regions = [];
    }
    this.userId = userId;
    this._id = _id; // Initialize _id
    this.favoriteResumes = favoriteResumes; // Initialize favoriteResumes
  }

  static fromJSON(json) {
    return new User(
      json.name, // Map API field `name` to frontend field `fullName`
      json.userName,
      json.userType,
      // json.dob,
      json.email,
      json.profilePhoto || profilePhotoPlaceholder,
      json.organization || "",
      json.phoneNumber || json.phone || json.phone_number || "",
      json.jobTitle || json.job || json.job_title || "",
      (() => {
        if (Array.isArray(json.regions)) return json.regions;
        if (typeof json.regions === "string") {
          try {
            const candidate = JSON.parse(json.regions);
            if (Array.isArray(candidate)) return candidate;
          } catch (error) {
            // fall through to comma split
          }
          return json.regions
            .split(",")
            .map((entry) => entry.trim())
            .filter(Boolean);
        }
        if (json.regions) return [json.regions];
        return [];
      })(),
      json.userId,
      json._id, // Include _id in fromJSON mapping
      json.FavoriteResumes // Include favoriteResumes in fromJSON mapping
    );
  }

  toJSON() {
    return {
      name: this.fullName, // Map frontend field `fullName` to API field `name`
      userName: this.userName,
      userType: this.userType,
      // dob: new Date(this.dob).toLocaleDateString("en-US", {
      //   month: "2-digit",
      //   day: "2-digit",
      //   year: "numeric",
      // }), // Format to MM/DD/YYYY
      email: this.email,
      profilePhoto: this.profilePhoto , // Use placeholder if profilePhoto is missing
      organization: this.organization,
      phoneNumber: this.phoneNumber,
      jobTitle: this.jobTitle,
      regions: Array.isArray(this.regions) ? this.regions : [],
      userId: this.userId,
      _id: this._id, // Include _id in toJSON output
    };
  }
}

export default User;